import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  ETimeBucketType,
  EReportingTimeWindow,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import { TDAPositionsReportChartFilters, TPPRetailerId } from '../models/types'
import { IDAReportingPositionsChartResponse } from '../models'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetRetailerReportingDAPositionsChartV3({
  retailerId,
  advertiserId,
  campaignId,
  adGroupId,
  timeWindow,
  startDate,
  endDate,
  tzZone,
  aggregationType,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & TDAPositionsReportChartFilters &
  TPPRetailerId): UseQueryResult<
  AxiosResponse<IDAReportingPositionsChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingDAPositionsChart_${retailerId}_${advertiserId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate }],
    () => {
      return coreAPIV3.retailerReporting().getRetailerPositionsReportChart(
        retailerId,
        generateCorrelationId(),
        advertiserId,
        campaignId,
        adGroupId,
        timeWindow as unknown as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        aggregationType as ETimeBucketType,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status
      )
    },
    { suspense, enabled }
  )
}
